/**
 * Shared with me in the sidebar: items the user can open whose parent they
 * cannot, from the existing `/hierarchy/shared-with-me` source (they have no
 * place in the tree). Hidden when there are none.
 */

import { useNavigate } from 'react-router';
import type { HierarchyNode } from '@bower/shared/types/api';

import { ROUTES } from '../../../constants/routes';
import { useSharedWithMe } from '../../../hooks/data/useHierarchy';
import { useEntityNavigation } from '../../../hooks/entity/useEntityNavigation';
import { getHierarchyNodeGlyph } from '../../../theme/entityIcons';
import { SidebarRow, SidebarSection } from './SidebarSection';

export function SharedWithMeSection() {
  const navigate = useNavigate();
  const { openEntity } = useEntityNavigation({ fromWorkspace: true });
  const { data: nodes = [] } = useSharedWithMe();

  if (nodes.length === 0) return null;

  const open = (node: HierarchyNode) => {
    if (node.type === 'project') navigate(ROUTES.collection(node.id));
    else openEntity(node.artifactType ?? 'note', node.id, { surface: 'shared_with_me' });
  };

  return (
    <SidebarSection label="Shared with me" testId="sidebar-shared-with-me">
      {nodes.map((node) => (
        <SidebarRow
          key={node.id}
          label={node.name}
          glyph={getHierarchyNodeGlyph(node.type, node.artifactType)}
          onOpen={() => open(node)}
        />
      ))}
    </SidebarSection>
  );
}
